/** Public route + menu constants for host integration */
export const SQL_STUDIO_ROUTE = "/tools/sql-studio";
export const SQL_STUDIO_LABEL = "SQL Studio";
